import Enum from '/@/modules/core/app/helpers/Enum';

export class NavKey extends Enum {
  static NAV_ACCOUNTS = 'nav-accounts';

  static NAV_ADMINISTRATION = 'nav-administration';

  static NAV_ADVISOR_PRO_UPGRADE = 'nav-advisor-pro-upgrade';

  static NAV_ADVISOR_PRO_OPPORTUNITIES = 'nav-advisor-pro-opportunities';

  static NAV_ANALYTICS = 'nav-analytics';

  static NAV_ASK_CLARA = 'nav_ask_clara';

  static NAV_ASSETS_AND_LIABILITIES = 'nav-assets-and-liabilities';

  static NAV_CLARA = 'nav-clara';

  static NAV_CONTACTS = 'nav-contacts';

  static NAV_CONTENT_LIBRARY = 'nav-content-library';

  static NAV_DASHBOARD = 'nav-dashboard';

  static NAV_DOCUMENTS = 'nav-documents';

  static NAV_ESTATES = 'nav-estates';

  static NAV_ESTATE_BANK_ACCOUNTS = 'nav-estate-bank-accounts';

  static NAV_GIVE_FEEDBACK = 'nav-give-feedback';

  static NAV_INBOX = 'nav-inbox';

  static NAV_INHERITANCE = 'nav-inheritance';

  static NAV_LEGACY_LETTERS = 'nav-legacy-letters';

  static NAV_MARKETPLACE = 'nav-marketplace';

  static NAV_MEMBERS = 'nav-members';

  static NAV_MYTEAM = 'nav-my-team';

  static NAV_NEXT_STEPS = 'nav-next-steps';

  static NAV_NOTIFICATIONS = 'nav-notifications';

  static NAV_OVERVIEW = 'nav-overview';

  static NAV_PLANNING = 'nav-planning';

  static NAV_RESOURCES = 'nav-resources';

  static NAV_RESOURCE_CENTER = 'nav-resource-center';

  static NAV_SETTLEMENT = 'nav-settlement';

  static NAV_TEAMS_DROPDOWN = 'nav-teams-dropdown';

  static NAV_TOOLS = 'nav-tools';

  static NAV_VAULTS = 'nav-vaults';

  /**
   * @returns {string[]}
   */
  static getFooterItemKeys() {
    return [
      NavKey.NAV_ADVISOR_PRO_UPGRADE,
      NavKey.NAV_CLARA,
      NavKey.NAV_NOTIFICATIONS,
      NavKey.NAV_INBOX,
      NavKey.NAV_GIVE_FEEDBACK
    ];
  }

  /**
   * @returns {string[]}
   */
  static getHeaderItemKeys() {
    return [NavKey.NAV_TEAMS_DROPDOWN];
  }

  /**
   * @param {AuthUser} authUser
   *
   * @returns string[]
   */
  static getNavItemKeysOrder(authUser) {
    if (authUser.isInFinancialAdvisorProfessionGroup) {
      return [
        NavKey.NAV_OVERVIEW,
        NavKey.NAV_PLANNING,
        NavKey.NAV_SETTLEMENT,
        NavKey.NAV_ANALYTICS,
        NavKey.NAV_ADVISOR_PRO_OPPORTUNITIES,
        NavKey.NAV_MYTEAM,
        NavKey.NAV_RESOURCES
      ];
    }

    return [];
  }
}
